/* styles.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1crf%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12vemgnk%7Bbackground-repeat%3Ano-repeat%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkvkf5%7Bbackground-color%3Avar(--ds-skeleton-subtle%2C%2317171708)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1lrws7h6%7Bbackground-size%3A300%25%20100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y44v1jas%7Banimation%3Akv5mpd0%201.2s%20linear%20infinite%20forwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20kv5mpd0%7B0%25%7Bbackground-position%3A100%25%200%7Dto%7Bbackground-position%3A-100%25%200%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1yb4%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx2vrvc%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
import { type CSSProperties, type ReactNode } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is used by the JSX pragma

import { type Props } from './types';

// eslint-disable-next-line @compiled/no-invalid-css-map
const shimmer = null;
const styles = {
  loadingSkeletonContainer: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4",
  loadingSkeleton: "_2rko12b0 _y44v1jas _1lrws7h6 _bfhkvkf5 _12vemgnk _4t3i1crf _1bsb1osq"
};
export function LoadingSkeletonContainer({
  children,
  margin,
  style
}: {
  children?: ReactNode;
  margin?: string;
  style?: CSSProperties;
}): JSX.Element {
  return <div
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic margin passed as inline style
  style={{
    margin: margin ?? '0px',
    ...style
  }} className={ax([styles.loadingSkeletonContainer])}>
			{children}
		</div>;
}
export function LoadingSkeleton({
  marginLeftPx = 0,
  marginBottomPx = 0,
  marginRightPx = 0,
  marginTopPx = 0,
  width = '100%',
  borderRadius = "var(--ds-radius-small, 4px)",
  backgroundColor = "var(--ds-skeleton-subtle, #17171708)",
  shimmerColor = "var(--ds-skeleton, #0515240F)",
  height = '12px'
}: Props): JSX.Element {
  return <div
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic props passed as inline styles
  style={{
    width,
    height,
    borderRadius,
    backgroundColor,
    backgroundImage: `linear-gradient( to right, transparent 0%, transparent 40%, ${shimmerColor} 50%, transparent 60%, transparent 100%)`,
    marginRight: `${marginRightPx}px`,
    marginTop: `${marginTopPx}px`,
    marginBottom: `${marginBottomPx}px`,
    marginLeft: `${marginLeftPx}px`
  }} className={ax([styles.loadingSkeleton])} />;
}